(function () {
  angular.module("akitabox.desktop.admin", [
    "ui.router",
    "akitabox.core.router",
    "akitabox.desktop.admin.job",
  ]);
})();
